<!--
 * @Author: hucaili 735856642@qq.com
 * @Date: 2023-06-09 20:24:37
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2024-04-08 11:40:33
 * @FilePath: \fe-crm\src\components\public\xl-update-records\xl-update-records.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-com-follow-records">
    <!-- width="480px" -->
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" title-align="start" :mask-closable="false" unmount-on-close :ok-loading="loading" class="follow-modal">
      <template #title> {{ followTitle }} </template>
      <jw-form :model="form" label-align="left" ref="followForm" @submit="handleSubmit" class="select-item">
        <jw-form-item field="followPost" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId === qijieOrgId">
          <template #label>
            <xl-label-text :value="$t('跟进人岗位')" :row="1" />
          </template>
          <jw-select v-model="form.followPost" :placeholder="$t('请选择跟进人岗位')" :style="{ width: '320px' }" allow-clear allow-search :options="qjkjPositionType"> </jw-select>
        </jw-form-item>
        <jw-form-item field="recordTime" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="{ required: true, message: $t('跟进时间是必填项') }" :validate-trigger="['blur', 'input']">
          <template #label>
            <xl-label-text :value="$t('跟进时间')" :row="1" />
          </template>
          <jw-date-picker showTime :style="{ width: '320px' }" size="small" position="br" v-model="form.recordTime" format="YYYY-MM-DD HH:mm" unmount-on-close />
        </jw-form-item>

        <template v-if="userInfo?.orgId === qijieOrgId">
          <jw-form-item field="followObjective" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('跟进目的')" :row="1" />
            </template>
            <jw-select v-model="form.followObjective" :placeholder="$t('请选择跟进目的')" :style="{ width: '320px' }" allow-clear allow-search :options="qjkjfollowObjective"> </jw-select>
          </jw-form-item>
          <jw-form-item field="extFollowObjective" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('其他跟进目的')" :row="1" />
            </template>
            <jw-input v-model="form.extFollowObjective" :placeholder="$t('输入其他跟进目的')" :style="{ width: '320px' }" />
          </jw-form-item>
        </template>

        <jw-form-item field="followMethod" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="{ required: true, message: $t('跟进方式是必选项') }" :validate-trigger="['blur', 'input']">
          <template #label>
            <xl-label-text :value="$t('跟进方式')" :row="1" />
          </template>
          <jw-select v-model="form.followMethod" :placeholder="$t('请选择跟进方式')" :style="{ width: '320px' }" allow-clear allow-search :options="getfollowType(userInfo?.orgId)"> </jw-select>
        </jw-form-item>
        <!-- 华映定制，隐藏我方参会人 -->
        <jw-form-item field="selfJoinPersons" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId !== huaYingOrdId">
          <template #label>
            <xl-label-text :value="$t(userInfo?.orgId != qijieOrgId ? '我方参会人' : '我方参与人')" :row="1" />
          </template>
          <jw-input v-model="form.selfJoinPersons" :placeholder="$t('输入人员名称，如有多人以，分割')" :style="{ width: '320px' }" />
        </jw-form-item>

        <jw-form-item field="newSelfJoinPersons" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId === huaYingOrdId" :rules="{ required: true, message: $t('我方参会人是必选项') }" asterisk-position="end">
          <template #label>
            <xl-label-text :value="$t('我方参会人')" :row="1" />
          </template>
          <xl-tree-member-modal ref="xlTreeMember" :tree="tree" @cb="getSelfVal($event, form.newSelfJoinPersons, index)" :depart="selfSearchData?.departList" :user="selfSearchData?.userList">
            <jw-input-tag v-model="form.newSelfJoinPersons" class="user-depart-tags" :placeholder="$t('请选择参会人员')" allow-clear @remove="removeSelfUserDepart" @clear.stop="clearSelfAll" :style="{ width: '320px' }"> </jw-input-tag>
          </xl-tree-member-modal>
        </jw-form-item>

        <jw-form-item field="customerJoinPersons" :rules="{ required: userInfo?.orgId === huaYingOrdId, message: $t('客户参会人是必选项') }" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t(userInfo?.orgId != qijieOrgId ? '客户参会人' : '客户参与人')" :row="1" />
          </template>
          <jw-input v-model="form.customerJoinPersons" :placeholder="$t('输入人员名称，如有多人以，分割')" :style="{ width: '320px' }" />
        </jw-form-item>
        <jw-form-item field="customIssue" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId === qijieOrgId">
          <template #label>
            <xl-label-text :value="$t('客户问题')" :row="1" />
          </template>
          <jw-textarea v-model="form.customIssue" :placeholder="$t('请填写客户问题')" :style="{ width: '320px' }" />
        </jw-form-item>
        <jw-form-item field="issueKind" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId === qijieOrgId">
          <template #label>
            <xl-label-text :value="$t('问题类别')" :row="1" />
          </template>
          <jw-select v-model="form.issueKind" :placeholder="$t('请选择问题类别')" :style="{ width: '320px' }" allow-clear allow-search :options="qjkjProblemType"> </jw-select>
        </jw-form-item>
        <jw-form-item field="videoUrl" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId !== qijieOrgId">
          <template #label>
            <xl-label-text :value="$t('妙记链接')" :row="1" />
          </template>
          <jw-input v-model="form.videoUrl" :placeholder="$t('请填写会议妙记链接')" :style="{ width: '320px' }" />
        </jw-form-item>
        <jw-form-item field="content" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="markdownValidate" :validate-trigger="['blur', 'input']">
          <template #label>
            <xl-label-text :value="$t('跟进详情')" :row="1" />
          </template>
          <markdown ref="markdownEditor" :value="form.content" height="200px" width="320px" @blurEvent="blurEvent"></markdown>
        </jw-form-item>
        <jw-form-item field="attachmentContent" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="[1, 2, 3, 12].indexOf(type) > -1">
          <template #label>
            <xl-label-text :value="$t(userInfo?.orgId != qijieOrgId ? '附件内容' : '详情附件')" :row="1" />
          </template>
          <xl-upload :limit="10" :placeholder="$t('请选择附件内容')" v-model="form.attachmentContent" @cb="getFiles" :defaultFileList="form.attachmentContent" class="system-form-item-value" />
        </jw-form-item>
        <jw-form-item field="annexDesc" :label-col-style="{ width: '110px' }" class="form-label-text" v-if="userInfo?.orgId === qijieOrgId">
          <template #label>
            <xl-label-text :value="$t('附件说明')" :row="1" />
          </template>
          <jw-textarea v-model="form.annexDesc" :placeholder="$t('请填写附件说明')" :style="{ width: '320px' }" />
        </jw-form-item>
        <jw-form-item field="dateTime" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="followTimeRules" :required="isInten">
          <template #label>
            <xl-label-text :value="$t('下次跟进时间')" :row="1" />
          </template>
          <jw-date-picker v-model="form.dateTime[0]" :style="{ width: '130px', marginRight: '10px' }" :allow-clear="!isInten" />
          <div :style="{ backgroundColor: 'var(--color-fill-2)', borderRadius: 'var(--border-radius-small)' }">
            <jw-time-picker v-model="form.dateTime[1][0]" :step="{ minute: 15 }" disable-confirm format="HH:mm" :allow-clear="!isInten" style="width: 85px" @change="startTimeSelect('start', form.dateTime[1][0])" :placeholder="$t('开始时间')" />
            <span>-</span>
            <jw-time-picker v-model="form.dateTime[1][1]" format="HH:mm" :allow-clear="!isInten" :step="{ minute: 15 }" disable-confirm style="width: 85px" @change="startTimeSelect('end', form.dateTime[1][1])" :placeholder="$t('结束时间')" />
          </div>
        </jw-form-item>
        <jw-form-item field="nextFollowMethod" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="{ required: isInten, message: $t('下次跟进方式是必选项') }" :validate-trigger="['blur', 'input']">
          <template #label>
            <xl-label-text :value="$t('下次跟进方式')" :row="1" />
          </template>
          <jw-select v-model="form.nextFollowMethod" :placeholder="$t('请选择下次跟进方式')" :style="{ width: '320px' }" allow-clear :options="getfollowType(userInfo?.orgId)" allow-search> </jw-select>
        </jw-form-item>

        <jw-form-item field="nextFollowPersons" :label-col-style="{ width: '110px' }" class="form-label-text" :disabled="sourceType === 'editRecord' && canEdit" v-if="userInfo?.orgId !== qijieOrgId">
          <template #label>
            <xl-label-text :value="$t('下次参会人员')" :row="1" />
          </template>
          <xl-tree-member-modal ref="xlTreeMember" :tree="tree" @cb="getVal($event, form.nextFollowPersons, index)" :depart="searchData?.departList" :user="searchData?.userList" :disabled="sourceType === 'editRecord' && canEdit">
            <jw-input-tag v-model="form.nextFollowPersons" class="user-depart-tags" :placeholder="$t('请选择下次参会人员')" allow-clear @remove="removeUserDepart" @clear.stop="clearAll" :style="{ width: '320px' }"> </jw-input-tag>
          </xl-tree-member-modal>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, ref, inject, computed } from 'vue';
import { Modal } from '@arco-design/web-vue';
import dayjs from 'dayjs';
import { zhiShuOrgId, followType, hyzbFollowType, huaYingOrdId, qijieOrgId, qjkjFollowType, qjkjProblemType, qjkjPositionType, qjkjfollowObjective } from '@/utils/const';
import Markdown from '@/components/markdown/markdown.vue';
import { useFollowRecords, useScheduleStore, useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
import { Message } from '@arco-design/web-vue';
// import markdown from '../../../../components/markdown/markdown.vue';
export default {
  components: { Markdown },
  name: 'XlFollowRecords',
  setup(props, ctx) {
    const { userInfo } = useUserStore();
    console.log(userInfo, 102030);
    const { t } = useI18n();
    const followForm = ref('');
    // markdown
    const markdownEditor = ref();
    const isInten = ref(false);
    const followRecords = useFollowRecords(); //动态记录
    const scheduleStore = useScheduleStore(); //日程列表
    const canEdit = ref(true);
    // 选择部门和人员
    const tree = reactive({
      checkDepartment: false,
      isAll: true
    });

    const selfuserIds = computed(() => data.selfSearchData?.userList?.map((el) => el.id));
    const nextUserIds = computed(() => data.searchData?.userList?.map((el) => el.id));
    // 下次跟进人员
    const getVal = (v) => {
      data.searchData = v;
      const userNames = computed(() => v?.userList?.map((u) => u.userName));
      // const userIds = computed(() => v?.userList?.map((u) => u.id));
      if (userNames.value) {
        followForm.value.clearValidate(['nextFollowPersons']);
      }
      data.form.nextFollowPersons = userNames.value;
      // data.form.nextFollowPersonIds = userIds.value;
    };
    // 跟进方式列表判断
    const getfollowType = (type) => {
      let sourceType = '-';
      switch (type) {
        case huaYingOrdId:
          sourceType = hyzbFollowType;
          break;
        case qijieOrgId:
          sourceType = qjkjFollowType;
          break;
        default:
          sourceType = followType;
      }
      console.log('选项sourceType', sourceType);
      return sourceType;
    };
    // 我方参会人员新
    const getSelfVal = (v) => {
      console.log(113, v);
      data.selfSearchData = v;
      const userNames = computed(() => v?.userList?.map((u) => u.userName));
      // const userIds = computed(() => v?.userList?.map((u) => u.id));

      if (userNames.value) {
        followForm.value.clearValidate(['newSelfJoinPersons']);
      }
      data.form.newSelfJoinPersons = userNames.value;
    };

    // 删除用户或部门
    const removeUserDepart = (removed) => {
      const userItem = data.searchData?.userList.findIndex((item) => item.userName === removed);
      if (userItem !== -1) {
        data.searchData?.userList?.splice(userItem, 1);
      }
    };

    // 删除用户或部门
    const removeSelfUserDepart = (removed) => {
      const userItem = data.selfSearchData?.userList.findIndex((item) => item.userName === removed);
      if (userItem !== -1) {
        data.selfSearchData?.userList?.splice(userItem, 1);
      }
    };

    // 清除所有
    const clearAll = (ev) => {
      console.log(101, ev);
      if (data.searchData) {
        data.searchData.userList = [];
      }
    };

    // 清除所有
    const clearSelfAll = (ev) => {
      console.log(101, ev);
      if (data.selfSearchData) {
        data.selfSearchData.userList = [];
      }
    };

    const setFollowMethod = (info) => {
      return info?.orgId == zhiShuOrgId ? '4' : info?.orgId != huaYingOrdId ? '0' : '1';
    };

    const updateRecordShow = (record) => {
      data.visible = true;
      data.isUpdate = record?.isUpdate; //是否刷新动态记录列表 true：刷新 ，不传或者false：不刷新
      data.sourceType = record.sourceType; //页面来源
      data.followTitle = record.followTitle; //标题

      // data.fClueId = record?.id; //记录id; //业务id
      data.form.recordTime = Date.now();
      // nextTick(() => {
      //   const dateStr = record?.recordTime; // 时间字符串，例如 2023-12-01 09:30:00
      //   const timestamp = new Date(dateStr).getTime(); // 将时间字符串转换为时间戳
      //   data.form.recordTime = timestamp ? timestamp : Date.now();
      // });
      if (isInten.value) {
        data.form.dateTime[0] = dayjs(new Date()).format('YYYY-MM-DD');
        data.form.dateTime[1] = [dayjs(new Date()).format('HH:mm'), dayjs(new Date().getTime() + 60 * 60 * 1000).format('HH:mm')];
      } else {
        data.form.dateTime = ['', ['', '']];
      }
      console.log(88, record);
      if (data.sourceType === 'addRecord') {
        //新增动态记录
        data.form.nextFollowPersons = [];
        if (userInfo.orgId === huaYingOrdId) {
          data.form.newSelfJoinPersons = [userInfo.userName];
          data.selfSearchData = {
            departList: [],
            userList: [
              {
                avatarOrigin: userInfo.avatarOrigin,
                id: userInfo.id,
                userName: userInfo.userName
              }
            ]
          };
        } else {
          data.form.newSelfJoinPersons = [];
          data.selfSearchData = null;
        }

        data.searchData = null;
        data.form.selfJoinPersons = '';
        data.form.customerJoinPersons = '';
        data.form.videoUrl = '';
        data.form.content = '';
        data.form.followMethod = setFollowMethod(userInfo);
        data.form.nextFollowMethod = '';
        data.form.attachmentContent = [];
        data.form.id = undefined;
        data.form.sessionId = undefined;
        data.form.taskId = undefined;
        data.form.calenderEventId = undefined;
        data.form.calenderId = undefined;
        data.form.customIssue = undefined;
        data.form.issueKind = undefined;
        data.form.annexDesc = undefined;
        data.form.followPost = undefined;
        data.form.followObjective = undefined;
        data.form.extFollowObjective = undefined;
      } else if (data.sourceType === 'list') {
        //线索/客户/商机首页列表-->动态记录
        data.form.selfJoinPersons = '';
        data.form.customerJoinPersons = '';
        data.form.videoUrl = '';
        data.form.content = '';
        // data.form.nextTodo = '';
        data.form.followMethod = setFollowMethod(userInfo);
        if (userInfo.orgId === huaYingOrdId) {
          data.form.newSelfJoinPersons = [userInfo.userName];
          data.selfSearchData = {
            departList: [],
            userList: [
              {
                avatarOrigin: userInfo.avatarOrigin,
                id: userInfo.id,
                userName: userInfo.userName
              }
            ]
          };
        } else {
          data.form.newSelfJoinPersons = [];
          data.selfSearchData = null;
        }
        data.form.nextFollowMethod = '';
        data.form.attachmentContent = [];
        data.form.id = undefined;
        data.form.sessionId = undefined;
        data.form.taskId = undefined;
        data.form.calenderEventId = undefined;
        data.form.calenderId = undefined;
        data.form.customIssue = undefined;
        data.form.issueKind = undefined;
        data.form.annexDesc = undefined;
        data.form.followPost = undefined;
        data.form.followObjective = undefined;
        data.form.extFollowObjective = undefined;
      } else if (data.sourceType === 'calllog') {
        //线索/客户/商机详情-->通话记录来源
        console.log('666从通话记录进入', record);
        // data.form.selfJoinPersons = record?.userName;
        data.form.sessionId = record?.sessionId;
        data.form.videoUrl = record?.videoUrl;
        data.form.attachmentContent = [];
      } else if (data.sourceType === 'schedule') {
        //线索/客户/商机详情-->日程
        console.log('666从日程中复选框进入', record);
        data.form.customerJoinPersons = '';
        data.form.taskId = record?.taskId;
        data.form.calenderEventId = record?.eventId;
        data.form.calenderId = record?.calenderId;
        data.tripFollow = record;
        data.form.attachmentContent = [];
        // data.fClueId = record.clueId;
        data.form.followMethod = record?.pitchInType;
        data.form.videoUrl = record?.videoUrl;
        data.form.selfJoinPersons = record?.selfJoinPersonsName;
      } else if (data.sourceType === 'editRecord') {
        //编辑动态记录
        data.followTitle = t('编辑跟进');
        console.log('修改动态记录', record, record.content, markdownEditor.value);
        data.recordId = record.id;

        data.form.nextFollowPersons = record?.nextFollowPersonList?.map((item) => item.userName); // 下次参会人

        data.searchData = {
          departList: [],
          userList: record?.nextFollowPersonList?.map((item) => ({
            avatarOrigin: item.avatarOrigin,
            id: item.id,
            userName: item.userName
          }))
        };

        // data.form.newSelfJoinPersons = record?.newSelfJoinPersonList?.map((item) => item.userName); // 我方参会人（新）
        data.form.newSelfJoinPersons = record?.newSelfJoinPersonList?.map((item) => item.userName); // 我方参会人（新）

        data.selfSearchData = {
          departList: [],
          userList: record?.newSelfJoinPersonList?.map((item) => ({
            avatarOrigin: item.avatarOrigin,
            id: item.id,
            userName: item.userName
          }))
        };

        data.form.selfJoinPersons = record?.selfJoinPersons;
        data.form.customerJoinPersons = record?.customerJoinPersons;
        data.form.videoUrl = record?.videoUrl;
        // data.form.recordTime = record?.recordTime;
        const timestamp = new Date(record?.recordTime).getTime(); // 将时间字符串转换为时间戳
        data.form.recordTime = timestamp ? timestamp : Date.now();
        console.log(396, record?.recordTime);
        // data.form.recordTime = dayjs(record?.recordTime).format('YYYY-MM-DD HH:mm');
        data.form.content = record?.content;
        data.form.attachmentContent = record?.attachmentContent;
        data.form.followMethod = `${record?.followMethod ?? ''}`;
        data.form.nextFollowMethod = `${record?.nextFollowMethod ?? ''}`;
        const dtS = record?.followStartTime;
        const dtE = record?.followEndTime;
        // 奇捷字段
        data.form.customIssue = record?.customIssue;
        data.form.issueKind = `${record?.issueKind ?? ''}`;
        data.form.annexDesc = record?.annexDesc;
        data.form.followPost = `${record?.followPost ?? ''}`;
        data.form.followObjective = record.followObjective;
        data.form.extFollowObjective = record.extFollowObjective;
        data.form.dateTime = dtS && dtE ? [dayjs(dtS).format('YYYY-MM-DD'), [dayjs(dtS).format('HH:mm'), dayjs(dtE).format('HH:mm')]] : ['', ['', '']];

        canEdit.value = record?.followStartTime && record?.followEndTime && record?.nextFollowMethod !== '';
      } else if (data.sourceType === 'schedule-edit') {
        //日程看板--动态记录
        console.log('从日程中添加动态记录', record);
        data.form.followMethod = record.pitchInType;
        data.form.videoUrl = record.videoUrl;
        data.form.selfJoinPersons = record.selfJoinPersonsName;
        data.form.taskId = record?.taskId;
        // data.form.recordTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm');
        data.form.calenderEventId = record?.eventId;
        data.form.calenderId = record?.calenderId;
        data.form.attachmentContent = [];
        data.form.nextFollowMethod = '';
      }
    };
    // 添加跟进弹窗的确认按钮
    const handleOk = () => {
      followForm.value.handleSubmit();
    };
    // 动态记录表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log(392202, data.form.content);
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        followForm.value.setFields(errorArray);
        return;
      }
      if (data.getFilesList.length > 0 && data.form.attachmentContent?.length != data.getFilesList?.length) {
        //文件未上传完给提示
        Message.warning(t('文件未上传完成,请稍后提交！'));
        return;
      }
      if (data.sourceType === 'editRecord') {
        updateFollow();
      } else {
        addFollow();
      }
    };
    //  添加跟进弹窗的取消按钮
    const handleCancel = () => {
      data.visible = false;
      followForm.value.resetFields(); //清空表单
      data.form.content = '';
      if (data.sourceType === 'schedule') {
        ctx.emit('checkCancel');
      }
    };
    // 移除图片前效验
    const beforeRemove = (file) => {
      return new Promise((resolve, reject) => {
        Modal.confirm({
          title: t('tips.deleteImgAlert') + '?',
          content: t('确认删除') + ` ${file.name}`,
          onOk: () => resolve(true),
          onCancel: () => reject('cancel')
        });
      });
    };
    // 自定义表单效验规则
    const followTimeRules = [
      {
        validator: (value, cb) => {
          console.log(82, data.form.dateTime, value);
          if (isInten.value) {
            if (value?.[0] || value?.[1]) {
              return cb(t('下次跟进时间为必填项'));
            }
          }
          return;
        }
      }
    ];
    // 添加动态记录
    const addFollow = async () => {
      data.loading = true;
      let followStartTime = '';
      let followEndTime = '';
      if (data.form.dateTime[0] && data.form.dateTime[1][0] && data.form.dateTime[1][1]) {
        followStartTime = dayjs(data.form.dateTime[0] + ' ' + data.form.dateTime[1][0]).format('YYYY-MM-DD HH:mm:ss');
        followEndTime = dayjs(data.form.dateTime[0] + ' ' + data.form.dateTime[1][1]).format('YYYY-MM-DD HH:mm:ss');
      }
      const params = {
        ...data.form,
        recordTime: dayjs(data.form.recordTime).format('YYYY-MM-DD HH:mm'),
        id: data.id,
        type: data.type,
        followStartTime,
        followEndTime,
        isUpdate: data.isUpdate, // 是否刷新动态记录列表
        nextFollowPersons: nextUserIds.value, // 下次参会人
        newSelfJoinPersons: selfuserIds.value // 我方参会人（新）
      };
      // delete params.newSelfJoinPersonIds;
      // delete params.nextFollowPersonIds;
      // delete params.newSelfJoinPersons;
      // delete params.nextFollowPersons;

      console.log('提交信息', params);
      followRecords
        .addFollow(params)
        .then((res) => {
          if (!res.error) {
            console.log(ctx);
            ctx.emit('cb');
            data.loading = false;
            data.visible = false;
            if (data.type === 1) {
              scheduleStore.getScheduleList({
                id: data.id,
                type: data.type
              });
            }
          }
        })
        .finally((err) => {
          console.log(err);
          data.loading = false;
          data.searchData = null;
          data.selfSearchData = null;
        });
    };

    // 辑编动态记录
    const updateFollow = async () => {
      data.loading = true;
      let followStartTime = '';
      let followEndTime = '';
      if (data.form.dateTime[0] && data.form.dateTime[1][0] && data.form.dateTime[1][1]) {
        followStartTime = dayjs(data.form.dateTime[0] + ' ' + data.form.dateTime[1][0]).format('YYYY-MM-DD HH:mm:ss');
        followEndTime = dayjs(data.form.dateTime[0] + ' ' + data.form.dateTime[1][1]).format('YYYY-MM-DD HH:mm:ss');
      }
      const params = {
        ...data.form,
        recordTime: dayjs(data.form.recordTime).format('YYYY-MM-DD HH:mm'),
        id: data.recordId,
        type: data.type,
        followStartTime,
        followEndTime,
        isUpdate: data.isUpdate,
        nextFollowPersons: nextUserIds.value, // 下次参会人
        newSelfJoinPersons: selfuserIds.value
      };
      // delete params.newSelfJoinPersonIds;
      // delete params.nextFollowPersonIds;

      console.log('我方参会人参数', params);

      followRecords
        .updateFollow(params)
        .then((res) => {
          if (!res.error) {
            ctx.emit('cb');
            data.loading = false;
            data.visible = false;
            if (data.type === 1) {
              scheduleStore.getScheduleList({
                id: data.id,
                type: data.type
              });
            }
          }
        })
        .finally(() => {
          data.loading = false;
        });
    };
    // 选择开始时间自动改变结束时间
    const startTimeSelect = (type, value) => {
      // console.log(283, type, value);
      const currentTime = data.form.dateTime?.[0] || dayjs(new Date()).format('YYYY-MM-DD');
      if (value) {
        if (type === 'start') {
          const startTime = currentTime + '' + value;
          const endTime = currentTime + '' + data.form.dateTime[1][1];
          const time = +dayjs(startTime);
          if (startTime > endTime) {
            // console.log('294开始时间大于结束时间', time);
            if (value?.split(':')[0] === '23') {
              data.form.dateTime[1][1] = dayjs(time).format('HH:mm');
            } else {
              data.form.dateTime[1][1] = dayjs(time + 60 * 60 * 1000).format('HH:mm');
            }
          }
        } else {
          const startTime = data.form.dateTime[1][0] ? currentTime + '' + data.form.dateTime[1][0] : dayjs(new Date()).format('YYYY-MM-DD  HH:mm');
          const endTime = currentTime + '' + value;
          const time = +dayjs(startTime);
          if (startTime > endTime) {
            data.form.dateTime[1][1] = dayjs(time).format('HH:mm');
          }
        }
      }
    };

    const data = reactive({
      searchData: {}, //下次跟进人列表
      selfSearchData: {}, //我方参与人
      visible: false,
      loading: false,
      type: inject('detailParams')?.entity || inject('defaultParams').entity,
      followTitle: '',
      fClueId: null,
      sourceType: 'default', //页面来源
      recordId: '',
      id: inject('detailParams')?.id || inject('defaultParams')?.id, //记录id
      clueId: '',
      tripFollow: {},
      form: {
        recordTime: Date.now(), //跟进时间
        dateTime: [dayjs(new Date()).format('YYYY-MM-DD'), [dayjs(new Date()).format('HH:mm'), dayjs(new Date().getTime() + 60 * 60 * 1000).format('HH:mm')]], //下次跟进时间
        content: markdownEditor.value?.getHTML() || '', //跟进内容
        videoUrl: '', //妙记地址url
        selfJoinPersons: '', //我方参与人
        customerJoinPersons: '', //客户方参与人
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, //时区
        followMethod: '0', //跟进方式
        nextFollowMethod: '', //下次跟进方式
        id: undefined, //只有type=4时传递，编辑动态记录---动态记录的ID
        sessionId: undefined, //只有type=2的时候传递的参数
        taskId: undefined, //只有type=3传递的参数
        calenderEventId: undefined, //只有type=3传递的参数
        calenderId: undefined, //只有type=3传递的参数
        attachmentContent: [],
        nextFollowPersons: [], // 下次跟进人员
        nextFollowPersonIds: [], //下次跟进人员id
        newSelfJoinPersons: [], // 我方参与人（新）
        newSelfJoinPersonIds: [], // 我方参与人（新）id
        customIssue: undefined, //奇捷客户问题
        issueKind: undefined, //奇捷问题类别
        annexDesc: undefined, //奇捷附件说明
        followPost: undefined, //奇捷跟进人岗位
        followObjective: undefined, //奇捷跟进目的
        extFollowObjective: undefined //奇捷其他跟进目的
      },
      getFilesList: [],
      isUpdate: false //是否刷新动态记录列表
    });
    const blurEvent = (value) => {
      console.log(392111, value);
      data.form.content = value;
      followForm.value?.validateField(['content'], (error) => {
        console.log(381, error);
        // 失去焦点时的表单自定义效验
        if (!error) {
          //在验证通过时时不返回callback()时 这一步进不来
          followForm.value?.clearValidate(['content']);
        }
      });
    };
    // 表单的自定义（field='content'）效验
    const markdownValidate = [
      {
        required: true,
        validator: (value, cb) => {
          console.log(392, value, data.form.content);
          const content = data.form.content?.replace('\n', '');
          console.log(3923, content);
          if (!content) {
            return cb(t('跟进详情是必填项'));
          }
          return;
        }
      }
    ];
    // 获取文件列表
    const getFiles = (files) => {
      console.log(1080, files);
      // 获取files.response.data的值,不要双层数组
      const filesList = [];
      data.getFilesList = [];
      data.getFilesList = files;
      files &&
        files.length > 0 &&
        files?.forEach((v) => {
          if (v?.response?.code == 0 && v.response?.data) {
            const url = v.response?.data;
            filesList.push(...url);
          }
        });
      data.form.attachmentContent = filesList;
    };
    return {
      followForm,
      handleCancel, //取消按钮
      beforeRemove, //图片移除前效验
      handleOk, //确认按钮
      handleSubmit,
      updateRecordShow,
      isInten,
      startTimeSelect,
      followTimeRules,
      followType,
      userInfo,
      hyzbFollowType,
      huaYingOrdId,
      markdownEditor,
      markdownValidate,
      blurEvent,
      getFiles,
      tree,
      getVal,
      getSelfVal,
      removeUserDepart,
      removeSelfUserDepart,
      clearAll,
      clearSelfAll,
      canEdit,
      getfollowType,
      qijieOrgId,
      qjkjFollowType,
      qjkjProblemType,
      qjkjPositionType,
      qjkjfollowObjective,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-update-records.less';
</style>
